import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignHorizontalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlignHorizontalCenter"><Path d="M20.5 3.5L3.5 3.5L3.5 20.5L20.5 20.5L20.5 3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M12 16.5L12 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlignHorizontalCenter;
